import script from "./HomeOrderUntil.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeOrderUntil.vue?vue&type=script&setup=true&lang=ts"

import "./HomeOrderUntil.vue?vue&type=style&index=0&id=5ecdc001&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ecdc001"]])

export default __exports__